<template>
<div id="container">
    <div class="container_wrap">
        <exploded-snb />
        <fragment>
            <router-view></router-view>
        </fragment>
    </div>
</div>
</template>
<script>
import axios                    from 'axios';
import { SDLUtil, MenuUtil }    from '@/utils/SDLUtil';

import ExplodedSnb              from '~vb/explodedView/ExplodedSnb';

export default {
    name: 'ExplodedView',
    components : {
        'exploded-snb'   : ExplodedSnb,
    },
    data() {
        return {

        }
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/explodedView/ExplodedView.vue